// Lazyload iframes on click

(function( $ ) {
	
	let $frames = $('[data-lazy-frame]');

	$frames.each(function(index, node) {
		$(node).on('click', function(event) {
			$(this).replaceWith( $(this).attr('data-lazy-frame') );
		});
	});

})( jQuery );
